export const GA_CATEGORIES = {
  TEMP_EMAIL: 'Temp Email',
  INBOX: 'Inbox',
  INTERACTION: 'Interaction',
};

/**
 * GA4 event tracking helper.
 * Mirrors the old ReactGA.event({ category, action, label }) shape.
 */
export function trackEvent({ category, action, label, value }) {
  try {
    if (typeof window === 'undefined') return;
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value,
    });
  } catch {
    // Never break UX because of analytics
  }
}

